import React, { useEffect, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

const DATES = [
    { day: 'Thu', date: '18 Jun', price: '₹9,435' },
    { day: 'Fri', date: '19 Jun', price: '₹9,199' },
    { day: 'Sat', date: '20 Jun', price: '₹9,199' },
    { day: 'Sun', date: '21 Jun', price: '₹10,065' },
    { day: 'Mon', date: '22 Jun', price: '₹9,044' },
    { day: 'Tue', date: '23 Jun', price: '₹9,044' },
    { day: 'Wed', date: '24 Jun', price: '₹8,374' },
    { day: 'Thu', date: '25 Jun', price: '₹9,120' },
    { day: 'Fri', date: '26 Jun', price: '₹9,560' },
    { day: 'Sat', date: '27 Jun', price: '₹8,999' },
    { day: 'Sun', date: '28 Jun', price: '₹10,210' },
    { day: 'Mon', date: '29 Jun', price: '₹9,340' },
    { day: 'Tue', date: '30 Jun', price: '₹9,080' },
    { day: 'Wed', date: '1 Jul', price: '₹8,650' },
]

const DEFAULT_BREAKPOINTS = {
    0: { slidesPerView: 2.5 },
    576: { slidesPerView: 4.5 },
    768: { slidesPerView: 5.5 },
    992: { slidesPerView: 6.5 },
    1200: { slidesPerView: 7.5 },
}

const FlightDateTabs = ({ dates = DATES, initialActiveIndex = 1, slidesPerView = 7.5, breakpoints = DEFAULT_BREAKPOINTS }) => {
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const swiperRef = useRef(null)
    const [activeIndex, setActiveIndex] = useState(initialActiveIndex)

    useEffect(() => {
        const swiper = swiperRef.current
        if (!swiper) return
        swiper.params.navigation = {
            ...swiper.params.navigation,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }
        swiper.navigation.init()
        swiper.navigation.update()
    }, [])

    return (
        <div className='flightDateTabs'>
            <button type="button" className='flightDateTabs__nav flightDateTabs__nav-prev' ref={prevRef} aria-label="Previous dates">
                &#8249;
            </button>

            <Swiper
                modules={[Navigation]}
                spaceBetween={0}
                slidesPerView={slidesPerView}
                onSwiper={(swiper) => { swiperRef.current = swiper }}
                breakpoints={breakpoints}
            >
                {dates.map((item, index) => (
                    <SwiperSlide key={index}>
                        <div
                            className={`flightDateTab ${activeIndex === index ? 'active' : ''}`}
                            onClick={() => setActiveIndex(index)}
                        >
                            <div className='flightDateTab__day'>{item.day}, {item.date}</div>
                            <div className='flightDateTab__price'>{item.price}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <button type="button" className='flightDateTabs__nav flightDateTabs__nav-next' ref={nextRef} aria-label="Next dates">
                &#8250;
            </button>
        </div>
    )
}

export default FlightDateTabs
